// extracted by mini-css-extract-plugin
module.exports = {"RecipeViewer":"RecipeViewer_RecipeViewer__39Yh7"};